import { Row } from './Row';
import { ListMetadata, RowData, RowWithNormalizedData, SerializedRow } from './types';
import { Cell } from './Cell';

export class List {
    config: ListMetadata;
    ID: string | null;
    parentList: List | null;
    rows: Array<Row>;

    get rootListId(): string {
        if (this.parentList) {
            return this.parentList.rootListId;
        } else {
            return this.config.id;
        }
    }

    constructor(listMetaData: ListMetadata, rowData: Array<RowData>, parentList: List | null) {
        this.config = listMetaData;
        this.parentList = parentList;
        this.ID = listMetaData.id;

        this.rows = rowData.map((row) => {
            return new Row(row, listMetaData.columns);
        });
    }

    getRow(rowId: string): Row | unknown {
        return (
            this.rows.find((row) => {
                return row.id === rowId;
            }) || {}
        );
    }

    /**
     * Get all non-empty cells of type LIST
     */
    getListCells(): Array<Cell> {
        return this.rows.reduce((lists: Array<Cell>, row) => {
            const cells = row.getListCells();

            lists = lists.concat(cells);

            return lists;
        }, []);
    }

    /**
     * Return an object with an array of objects representing a row.
     * Each row has properties with column names and their values.
     */
    serialize(): Array<SerializedRow | Record<string, unknown>> {
        return this.rows.map(function (row) {
            return row.serialize();
        });
    }

    /**
     * Serialize list for signs list widget
     * @param withNormalized - whether to include normalized version of
     * rows
     */
    serializeForSigns(
        withNormalized: boolean
    ): Array<RowData | RowWithNormalizedData | Record<string, unknown>> {
        return this.rows.map(function (row) {
            return row.serializeForSigns(withNormalized);
        });
    }
}
